import './card-partner.scss';

export default () => {
};
